export default __webpack_public_path__ + "static/media/vip-3.902515b2.gif";